// Tailwind color classes for the subscription-tier badge on the admin
// subscriptions page. The fallback (red) is intentional: any value not in
// the known set should stand out visually as "unexpected tier" to the admin.

const COLORS: Record<string, string> = {
  pro: "bg-green-100 text-green-800",
  admin: "bg-purple-100 text-purple-800",
  basic: "bg-blue-100 text-blue-800",
  free: "bg-gray-100 text-gray-800",
};

const FALLBACK_COLOR = "bg-red-100 text-red-800";

/** Returns the CSS classes for a subscription-tier badge. */
export function subscriptionBadgeColor(type: string | null | undefined): string {
  if (!type) return FALLBACK_COLOR;
  return COLORS[type.toLowerCase()] ?? FALLBACK_COLOR;
}

/** Returns the human-readable label for a subscription tier (or "aucun" when absent). */
export function subscriptionBadgeLabel(type: string | null | undefined): string {
  return type || "aucun";
}
